module.exports = __webpack_public_path__ + "static/media/Gallary5.fd068add.png";